module.exports = new __parcel__URL__("80216_h.d4085c2c.jpg").toString();